// extracted by mini-css-extract-plugin
module.exports = {"root":"PackageUpload_root__3ENOc","disabled":"PackageUpload_disabled__3pm0M","note":"PackageUpload_note__2Bves"};